<template>
    <v-form ref="form">
        <v-container fluid>
            <v-dialog
                    v-model="backToExpensesDialog"
                    width="500"
            >
                <v-card>
                    <v-card-title
                            class="headline"
                            primary-title
                    >
                        {{__('dialogs.back_to_expenses_title')}}
                    </v-card-title>

                    <v-card-text>
                        {{__('dialogs.back_to_expenses_text')}}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                flat
                                @click="setStep(7); backToExpensesDialog = false;"
                        >
                            {{__('dialogs.back_to_expenses_action')}}
                        </v-btn>
                        <v-btn
                                color="primary"
                                flat
                                @click="setStep(10); backToExpensesDialog = false;"
                        >
                            {{__('general.next')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                    v-model="skipUploadDialog"
                    width="500"
            >
                <v-card>
                    <v-card-title
                            class="headline"
                            primary-title
                    >
                        {{__('dialogs.skip_upload_title')}}
                    </v-card-title>

                    <v-card-text>
                        {{__('dialogs.skip_upload_text')}}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                flat
                                @click="setStep(10); skipUploadDialog = false;"
                        >
                            {{__('dialogs.skip_upload_action_skip')}}
                        </v-btn>
                        <v-btn
                                color="primary"
                                flat
                                @click=" nextStep(); skipUploadDialog = false;"
                        >
                            {{__('dialogs.skip_upload_action')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <div class="headline">{{__('labels.sum')}}</div>
            <v-layout row wrap>
                <template v-if="taxes === '19'">
                    <v-flex xs12 md6>
                        <s-price-field
                                :value="sumNetto"
                                :label="__('invoices.total_sum') + ' ' + __('invoices.netto')"
                                readonly>
                        </s-price-field>
                    </v-flex>
                    <v-flex xs12 md6>
                        <s-price-field
                                :value="sumTaxes"
                                :label="__('invoices.taxes') + ' '+taxesText+'%'"
                                readonly>
                        </s-price-field>
                    </v-flex>
                    <v-flex xs12>
                        <s-price-field
                                :value="sumBrutto"
                                :label="__('invoices.total_sum') + ' ' + __('invoices.brutto')"
                                readonly>
                        </s-price-field>
                    </v-flex>
                </template>
                <v-flex xs12 v-else>
                    <s-price-field
                            :value="sumNetto"
                            :label="__('invoices.total_sum')"
                            readonly>
                    </s-price-field>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex shrink>
                    <button-previous></button-previous>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex shrink>
                    <button-next @click="nextButtonClick()"></button-next>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapMutations} from 'vuex'
    import {mapActions} from 'vuex'

    export default {
        name: "SumStep",
        data: function() {
            return {
                backToExpensesDialog: false,
                skipUploadDialog: false
            }
        },
        computed: {
            ...mapState('form', [
                'taxes',
                'royalties',
                'expensesSum',
                'performanceDates',
            ]),
            sumNetto: {
                get() {
                    return this.royalties + this.expensesSum;
                },
            },
            sumTaxes: {
                get() {
                    let flattenedDates = _.flatten(_.map(this.performanceDates, 'dates'))
                    let firstDate = flattenedDates[0]
                    if (this.$moment(firstDate).isBetween(this.$moment('2020-06-30'), this.$moment('2021-01-01'))) {
                        return Math.round(this.sumNetto * 0.16);
                    }
                    return Math.round(this.sumNetto * 0.19);
                },
            },
            sumBrutto: {
                get() {
                    return this.sumNetto + this.sumTaxes;
                },
            },
            taxesText() {
                let flattenedDates = _.flatten(_.map(this.performanceDates, 'dates'))
                let firstDate = flattenedDates[0]
                if (this.$moment(firstDate).isBetween(this.$moment('2020-06-30'), this.$moment('2021-01-01'))) {
                    return 16
                }
                return 19
            }
        },
        methods: {
            ...mapMutations('stepper', [
                'nextStep',
                'setStep'
            ]),
            ...mapActions('form', [
                'setError',
            ]),
            nextButtonClick() {
                if (this.expensesSum > 0) {
                    this.skipUploadDialog = true;
                } else {
                    this.backToExpensesDialog = true;
                }
            },
        },
    }
</script>

<style scoped>

</style>